export function More() {
  const MoreBtn = $('.Btn_more');
  const MoreContent = $('.Content_more');
  const CloseBtn = $('.Btn_close');


  // MoreContentの開閉
  function ContentOpen() {
    MoreContent.attr('aria-hidden','false');
    MoreContent.slideDown();
    MoreBtn.fadeOut(100);
  }
  function ContentClose() {
    MoreContent.attr('aria-hidden','true');
    MoreContent.slideUp();
    MoreBtn.fadeIn(200);
  }

  // Menu ButtonのARIA属性値
  function changeButtonClose() {
    MoreBtn.attr('aria-selected','false');
  }
  function changeButtonOpen() {
    MoreBtn.attr('aria-selected','true');
  }


  // Menu ButtonクリックでMenuオープン
  function  OpenMore() {
    MoreBtn.click(function () {
        ContentOpen();
        changeButtonOpen();
    });
  }
    // Close ButtonクリックでMenu閉じる
  function CloseMore() {
    CloseBtn.click(function () {
        ContentClose();
        changeButtonClose();
    });
  }

  // ロード時とリサイズ時にリセット
  $(window).on('load', function () {
    if(window.matchMedia("(min-width: 941px)").matches) {
      changeButtonClose();

    }
  });
  $(window).on('resize', function () {
    if(window.matchMedia("(min-width: 941px)").matches) {
      changeButtonClose();
    }
  });

  $(function () {
    OpenMore();
    CloseMore();
  })
}